import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Button from '../../../../components/Button/Button';
import Input from '../../../../components/Input/Input';
import Select from '../../../../components/Select/Select';
import Modal from '../../../../components/Modal/Modal';
import './AddGroup.css';
import uploadIcon from '../../../../assets/uploadIcon.png';
import clearIcon from '../../../../assets/clearIcon.png';
//Services
import { groupService } from '../../../../services/Group';
//utils
import { formatDate } from '../../../../utils/utils';

const AddGroup = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { action, edtiData } = location.state;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState({ text: '', highlight: '' });
  const [modalMessage, setModalMessage] = useState('');
  const [errors, setErrors] = useState({});
  const [error, setError] = useState(false);
  const [organizations, setOrganizations] = useState([]);
  const [owners, setOwners] = useState([]);
  const [formData, setFormData] = useState({
    name: null,
    description: null,
    type: null,
    owner: null,
    image: null,
    imagePreview: null
  });

  useEffect(() => {
    fetchOrganizations();
    fetchOwners();
    console.log('action', action, 'edtiData', edtiData);
    if (action === 'edit' && edtiData) {
      fetchGroup();
    }
  }, [action, edtiData]);

  const fetchGroup = async () => {  
    try {
      const response = await groupService.dataGroup(edtiData.id);
      if(response) {
        setFormData({
          name: response.name,
          description: response.description,
          type: response.organization_type,
          owner: response.participants.find(member => member.role === 'owner').user_id,
          image: response.image_url,
          imagePreview: response.image_url
        });
      }
    } catch (error) {
      console.error('Error fetching group:', error);
    }
  }

  const fetchOrganizations = async () => {
    try {
      const response = await groupService.getOrganizations();
      if(response.length > 0) {
        const data = response.map(org => ({
          value: org.id,
          label: org.name
        }));
        setOrganizations(data);
      }
    } catch (error) {
      console.error('Error fetching organizations:', error);
    }
  };

  const fetchOwners = async () => {
    try {
      const params = {
        page: 1,
        items_per_page: 100
      };
      const response = await groupService.getOwners(params);
      if(response.status === 'success') {
        const data = response.data.data.map(owner => ({
          value: owner.id,
          label: owner.name
        }));
        setOwners(data);
      }
    } catch (error) {
      console.error('Error fetching owners:', error);
    }
  };

  const handleInputChange = (e, field) => {
    let value = e.target?.value;
    if(field === 'owner' || field === 'type') {
      value = e.target?.value.value;
    }
    console.log('handleInputChange', field, value);
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    // Clear error when user types
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData(prev => ({
          ...prev,
          image: file,
          imagePreview: reader.result
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = () => {
    setFormData(prev => ({
      ...prev,
      image: null,
      imagePreview: null
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim() || formData.name.trim() === '') {
      newErrors.name = 'Group name is required';
    }
    if (!formData.description.trim() || formData.description.trim() === '') {
      newErrors.description = 'Description is required';
    }
    if (!formData.type) {
      newErrors.type = 'Type of organization is required';
    }
    if (!formData.owner) {
      newErrors.owner = 'Owner is required';
    }
    if (!formData.image) {
      newErrors.image = 'Cover image is required';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    try {
      const groupData = new FormData();
      groupData.append('name', formData.name);
      groupData.append('description', formData.description);
      groupData.append('organization_type', formData.type);
      groupData.append('participant_ids', formData.owner);
      groupData.append('image', formData.image);
      groupData.append('owner_id', formData.owner)

      console.log('Enviando imagen al servidor...', {
        groupData
      });
      const response = await groupService.createGroup(groupData);
      if(response.status === 'success') {
        setModalTitle({ text: 'Group created', highlight: 'successfully' });
        setModalMessage('The group has been created successfully.');
        setError(false);
        setIsModalOpen(true);
      }else{
        setModalTitle({ text: 'Error creating', highlight: 'group' });
        setModalMessage('An error occurred while creating the group.');
        setError(true);
        setIsModalOpen(true);
      }
    } catch (err) {
      setModalTitle({ text: 'Error creating', highlight: 'group' });
      setModalMessage(err.message || 'An error occurred while creating the group.');
      setError(true);
      setIsModalOpen(true);
    }
  };

  const handleEdit = async () => {
    if (!validateForm()) return
    try {
      const groupData = new FormData()
      groupData.append('name', formData.name);
      groupData.append('description', formData.description);
      groupData.append('organization_type', formData.type);
      groupData.append('participant_ids', formData.owner);
      groupData.append('image', formData.image);

      const response = await groupService.updateGroup(edtiData.id, groupData);
      if(response) {
        setModalTitle({ text: 'Group updated', highlight: 'successfully' });
        setModalMessage('The group has been updated successfully.');
        setError(false);
        setIsModalOpen(true);

        setFormData({
          name: formData.name,
          description: formData.description,
          type: formData.type,
          owner: formData.owner,
          image: formData.image
        });
      }else{
        setModalTitle({ text: 'Error updating', highlight: 'group' });
        setModalMessage('An error occurred while updating the group.');
        setError(true);
        setIsModalOpen(true);
      }
    } catch (err) {
      setModalTitle({ text: 'Error updating', highlight: 'group' });
      setModalMessage(err.message || 'An error occurred while updating the group.');
      setError(true);
      setIsModalOpen(true);
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    if (!error) {
      navigate(-1);
    }
  };

  const handlePreviewImage = () => {
    if(formData.imagePreview){
      // Check if the imagePreview is already a complete URL or data URL (local image)
      if(formData.imagePreview.startsWith('data:') || formData.imagePreview.startsWith('blob:')) {
        // It's already a complete data URL (local image), return as is
        return formData.imagePreview;
      } else {
        // It's a remote image path, prepend the base URL
        return `${process.env.REACT_APP_URL}${formData.imagePreview}`;
      }
    } else {
      return null;
    }
  };

  const handleNameImage = () => {
    if(action === 'edit'){
      // Check if formData.image is a string (URL) or a File object
      if(formData.image && typeof formData.image === 'string'){
        return formData.image.split('/').pop();
      } else if(formData.image && formData.image instanceof File) {
        return formData.image.name;
      } else {
        return '';
      }
    }else{
      return formData.image ? formData.image.name : '';
    }
  };

  return (
    <div className="new-group-page">
      <div className="new-group-container">
        <h1 className="page-title">
          {action === 'add' ? 'New' : 'Edit'} group <span className="highlight">request</span>
        </h1>

        <div className="form-section">
          <div className="input-group">
            <div className="form-field">
              <div className="image-upload">
                <label>Cover image</label>
                <div className="preview-trigger">
                  <div className={`upload-area ${errors.image ? 'input-error' : ''}`}>
                    <input
                      type="text"
                      placeholder="Group image"
                      value={handleNameImage()}
                      readOnly
                    />
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageUpload}
                      id="group-image"
                      style={{ display: 'none' }}
                    />
                    <label htmlFor="group-image" className="upload-button">
                      <img src={uploadIcon} alt="upload" />
                    </label>
                    {formData.image && (
                      <button
                        type="button"
                        className="remove-image-button"
                        onClick={handleRemoveImage}
                      >
                        <label>x</label>
                      </button>
                    )}
                  </div>
                  {formData.imagePreview && (
                    <div className="image-preview" title="Image preview">
                      <img src={action === 'edit' ? 
                        handlePreviewImage(formData.imagePreview) : 
                        formData.imagePreview
                      } alt="Preview" />
                    </div>
                  )}
                </div>
                {errors.image && <span className="error-message">{errors.image}</span>}
              </div>
            </div>

            <div className="form-field">
              <label>Group name</label>
              <Input
                type="text"
                placeholder="Enter group name"
                value={formData.name}
                onChange={(e) => handleInputChange(e, 'name')}
                required
                error={errors.name}
              />
            </div>

            <div className="form-field">
              <label>Description</label>
              <Input
                type="text"
                label="Description"
                placeholder="Enter description"
                name="description"
                value={formData.description}
                onChange={(e) => handleInputChange(e, 'description')}
                error={errors.description}
                multiline
                rows={4}
                required
              />
            </div>
          </div>

          <div className="input-group">
            <div className="form-field">
              <label>Type of organization</label>
              <Select
                label="Type of organization"
                name="type"
                value={formData.type}
                onChange={(e) => handleInputChange(e, 'type')}
                options={organizations}
                error={errors.type}
                isClearable={false}
                required
              />
            </div>

            <div className="form-field">
              <label>Owner</label>
              <Select
                label="Owner"
                name="owner"
                value={formData.owner}
                onChange={(e) => handleInputChange(e, 'owner')}
                options={owners}
                error={errors.owner}
                isClearable={false}
                required
              />
            </div>
          </div>

          <div className="button-group">
            <Button
              variant="warning"
              onClick={() => navigate(-1)}
              fullWidth
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={action === 'edit' ? handleEdit : handleSubmit}
              fullWidth
            >
              {action === 'add' ? 'Save' : 'Update'}
            </Button>
          </div>
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        title={modalTitle}
        message={modalMessage}
        error={error}
        onConfirm={() => handleModalClose()}
      />
    </div>
  );
};

export default AddGroup;